import _objectSpread from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import usePlaceholder from './usePlaceholder';
import PlaceholderButton from './PlaceholderButton';
import { jsx as _jsx } from "react/jsx-runtime";
var Placeholder = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'span' : _ref$as,
    props = _objectWithoutProperties(_ref, ["as"]);
  var placeholderProps = usePlaceholder(props);
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, placeholderProps, {
    ref: ref
  }));
});
Placeholder.displayName = 'Placeholder';
export default Object.assign(Placeholder, {
  Button: PlaceholderButton
});